<template>
  <div class="home-onboard-tab content-main">
    <div class="content-main__centered">
      <h4 class="appMain--text mb-2">Onboard</h4>
      <p class="mb-4">
        Get new team members up to speed quickly and efficiently.
      </p>

      <v-card class="pa-6 text-center">
        <v-icon size="48" color="grey lighten-1" class="mb-4">
          mdi-clipboard-check-outline
        </v-icon>
        <h5 class="text-h6 mb-2">Onboarding Tools</h5>
        <p class="text-body-2 grey--text">
          Streamline your onboarding process for new hires.
        </p>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeOnboardTab',
};
</script>
